/**
 * 用户信息
 */
import CommonApi from 'api/common.js';
var url = '/dayaotex-server-admin';
var api = {
  /**
   * 判断是否为新版本
   */
  judgeVersion: function judgeVersion(data) {
    return CommonApi.post(url + '/version/judgeVersion', data);
  },
  getSysDictDataByDictType: function getSysDictDataByDictType(data) {
    return CommonApi.post('/dayaotex-server-admin/sysDict/getSysDictDataById', data);
  },
  getSysDictDataByDType: function getSysDictDataByDType(data) {
    return CommonApi.post('/dayaotex-server-admin/sysDict/getSysDictDataByDType', data);
  }
};
export default api;